import React from 'react';
import { Outlet } from 'react-router-dom';
import { CustomerNav } from './CustomerNav';
import { FloatingActions } from './FloatingActions';
export function CustomerLayout() {
  return <div className="min-h-screen w-full bg-[#0D0D0D]" data-id="element-136">
      <CustomerNav data-id="element-137" />
      <main className="w-full" data-id="element-138">
        <Outlet data-id="element-139" />
      </main>
      <footer className="border-t border-[#2A2A2A] py-8 px-4" data-id="element-140">
        <div className="max-w-7xl mx-auto text-center" data-id="element-141">
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-142">
            <div className="w-7 h-7 rounded-full bg-gradient-to-br from-[#C8A84E] to-[#B8963E] flex items-center justify-center" data-id="element-143">
              <span className="text-[#0D0D0D] font-bold text-[8px]" data-id="element-144">MHP</span>
            </div>
            <span className="text-sm font-semibold text-white" data-id="element-145">
              Mỹ Hòa Phát
            </span>
          </div>
          <p className="text-xs text-[#666666]" data-id="element-146">
            © 2025 Tập Đoàn Mỹ Hòa Phát. Hơn 15 năm cung cấp phụ tùng xe máy
            chính hãng.
          </p>
          <div className="flex items-center justify-center gap-4 mt-3" data-id="element-147">
            <a href="/ho-tro" className="text-xs text-[#666666] hover:text-[#C8A84E] transition-colors" data-id="element-148">
              Hỗ Trợ
            </a>
            <span className="text-[#2A2A2A]" data-id="element-149">·</span>
            <a href="https://myhoaphat.com" className="text-xs text-[#666666] hover:text-[#C8A84E] transition-colors" data-id="element-150">
              myhoaphat.com
            </a>
          </div>
        </div>
      </footer>
      <FloatingActions data-id="element-151" />
    </div>;
}